<template>
  <div>
    <!-- 承载bbs相关路由 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Home',

  data() {
    return {
    }
  }
}
</script>

<style scoped>
</style>
